import React from 'react';
import { CircularProgress, CircularProgressLabel } from '@chakra-ui/react';
import PropType from 'prop-types';

import colors from '../../../../styles/theme/foundation/colors';

function ProgressCircle({ percentage, isArchived = false }) {
  const decimalPoints = (percentage && percentage > 0 && percentage < 1) ? 2 : 0;
  const fixedPercentage = percentage && percentage.toFixed(decimalPoints);
  const progressColor = isArchived ? colors.greyScale['800'] : colors.success.primary['600'];
  const trackColor = isArchived ? colors.greyScale['500'] : colors.greyScale['300'];
  const labelColor = percentage > 0 ? progressColor : colors.greyScale['400'];

  return (
    <CircularProgress
      color={progressColor}
      size="42px"
      thickness="4px"
      trackColor={trackColor}
      value={fixedPercentage}
    >
      <CircularProgressLabel color={labelColor} fontSize="0.28em" fontWeight="semibold">
        {typeof percentage === 'number' ? `${fixedPercentage}%` : '-'}
      </CircularProgressLabel>
    </CircularProgress>
  );
}

ProgressCircle.propTypes = {
  percentage: PropType.number,
  isArchived: PropType.bool
};

export default ProgressCircle;
